import React from "react";
import { Link } from "react-router-dom";
import { useResource } from "../../hooks/resources";
import {
  GoChevronLeft as Back,
  GoLinkExternal as ExternalLink
} from "react-icons/go";
import ScrollToTop from "../../components/scroll-to-top";

export default function({ match }) {
  let [recipe, loading] = useResource("recipe", match.params.id);

  return (
    <>
      <ScrollToTop />

      <div className="bg-white -m-6 p-6">
        <div className="flex justify-between items-center">
          <Link
            to="/"
            className="py-2 px-1 inline-block font-medium text-blue-500"
          >
            <div className="flex items-center">
              <Back className="w-3 h-6 mr-1" /> Recipes
            </div>
          </Link>

          <Link
            to={`/recipes/${match.params.id}/edit`}
            className="py-2 text-blue-500 font-medium"
          >
            Edit
          </Link>
        </div>

        {loading ? (
          <p>Loading..</p>
        ) : (
          <div className="mt-6 lg:flex -mx-4 lg:-mx-8">
            <div className="lg:w-1/3 px-4 lg:px-8">
              <div className="">
                <div className="-mx-6 lg:mx-0 aspect-ratio lg:rounded-lg lg:overflow-hidden">
                  <div
                    className="bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${recipe.imageUrl})`
                    }}
                  />
                </div>
                <h1 className="mt-4 text-3xl font-bold leading-tight ">
                  {recipe.name}
                </h1>
              </div>

              <div className="hidden lg:block">
                <div className="mt-8">
                  <Ingredients recipe={recipe} />
                </div>
              </div>
            </div>
            <div className="lg:w-2/3 px-4 lg:px-8">
              <div className="mt-6 lg:mt-0">
                <div className="lg:hidden">
                  <Ingredients recipe={recipe} />
                </div>

                <h2 className="mt-12 lg:mt-0 text-2xl font-bold">
                  Instructions
                </h2>
                <ol className="mt-4 lg:flex lg:flex-wrap">
                  {recipe.instructions &&
                    recipe.instructions
                      .split("\n")
                      .filter(Boolean)
                      .map((instruction, index) => (
                        <li key={index} className="lg:w-1/2 lg:px-2 lg:flex">
                          <div className="w-full my-4 p-4 flex bg-gray-200 rounded-lg">
                            <span className="w-8 flex-shrink-0 text-2xl font-bold text-gray-900">
                              {index + 1}
                            </span>
                            <span className="pt-1">{instruction}</span>
                          </div>
                        </li>
                      ))}
                </ol>

                {recipe.recipeUrl ? (
                  <div className="py-12">
                    <a
                      target="blank"
                      className="text-blue-500 flex items-center"
                      href={recipe.recipeUrl}
                    >
                      View the original recipe
                      <ExternalLink className="ml-2" />
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function Ingredients({ recipe }) {
  return (
    <>
      <h2 className="text-2xl font-bold">Ingredients</h2>

      <ul className="mt-2 list-reset flex flex-wrap text-sm -mx-2">
        {recipe.ingredients &&
          recipe.ingredients.split("\n").map(ingredient => (
            <li className="w-1/2 md:w-1/3 lg:w-1/2" key={ingredient}>
              <div className="px-2 py-3 lg:py-2">{ingredient}</div>
            </li>
          ))}
      </ul>
    </>
  );
}
